import * as React from 'react';
import * as PropTypes from 'prop-types';
import * as moment from 'moment';
import * as classNames from 'classnames';
import UrlHelpers from '../../../shared/url_helpers';
import { QueryParamsUtil } from '@reverbdotcom/discovery-ui';
import PriceDisplay from '../../../shared/price_display';

class TableElement extends React.Component {
  emptyMessage() {
    return (
      <div className="module mb-2 position-relative">
        <p className="alert">{I18n.t('js.transactionHistory.noRecords')}</p>
      </div>
    );
  }

  signupParams() {
    const queryHash = {
      _aid: 'pg_signup_to_view',
      source: 'price_guide',
    };

    if (this.props.productTypeUuid) {
      queryHash.source_product_uuid = this.props.productTypeUuid;
    }

    return QueryParamsUtil.queryParamsForUrl(queryHash);
  }

  get hasTransactions() {
    return this.props.transactions && this.props.transactions.length > 0;
  }

  renderSignInMessage() {
    if (this.props.signedIn) { return null; }

    return (
      <h3 className="heading-3 mt-1 mb-2 align-center">
        <a data="signup-link" href={UrlHelpers.signupPath(this.signupParams())}>
          {I18n.t('js.transactionHistory.signUpToSee')}
        </a>
      </h3>
    );
  }

  render() {
    if (!this.hasTransactions) { return this.emptyMessage(); }

    return (
      <div>
        {this.renderSignInMessage()}
        <table
          className={classNames(
            'table transactions',
            { 'pg-transactions-blur': !this.props.signedIn },
          )}
        >
          <thead>
            <tr>
              <th className="date">{I18n.t('js.transactionHistory.date')}</th>
              <th className="condition">{I18n.t('js.transactionHistory.condition')}</th>
              <th className="final">{I18n.t('js.transactionHistory.soldPrice')}</th>
            </tr>
          </thead>

          <tbody>
            {this.props.transactions.map((transaction, index) =>
              (<tr key={index} className="transaction">
                <td className="date">{moment(transaction.date).format('l')}</td>
                <td className="condition">{transaction.condition}</td>
                <td className="final">
                  <span className="price-history-table-price">
                    <PriceDisplay price={transaction.price_final} />
                  </span>
                </td>
              </tr>))}
          </tbody>
        </table>
      </div>
    );
  }
}

TableElement.propTypes = {
  signedIn: PropTypes.bool,
  transactions: PropTypes.array,
  productTypeUuid: PropTypes.string,
};

export default TableElement;



// WEBPACK FOOTER //
// ./javascripts/components/price_guide/transaction_history/table/element.jsx